export default "__VITE_ASSET__Z$Ldnh4z__"